import { MapStorePlugin } from "./types";
import Logger from "../util/Logger";

const logger = new Logger("registerPlugin");

export const registeredPlugins: MapStorePlugin<any>[] = [];

export const registerPlugin = (component: MapStorePlugin<any>) => {
    logger.info(`Registering component ${JSON.stringify(component)}`);
    registeredPlugins.push(component);
};
